'use client'
import { useContext } from 'react'

import { FirebaseUserContext } from './FirebaseUserContextProvider'

export const useFirebaseToken = () => {
  return useContext(FirebaseUserContext).decodedJwt?.token
}
